class BarbaraDownloadPreview extends HTMLElement {
  connectedCallback() {
    if(this.hasAttribute('data-static-preview'))return;
    if(this.controller)return;
    this.controller=new AbortController();
    this.pages=[...this.querySelectorAll('[data-document]')];
    this.dialog=this.querySelector('dialog');
    this.image=this.querySelector('[data-document-image]');
    this.documentTitle=this.querySelector('[data-document-title]');
    this.counter=this.querySelector('[data-document-counter]');
    this.addEventListener('click',event=>{
      const page=event.target.closest('[data-document]');
      const close=event.target.closest('[data-document-close]');
      const previous=event.target.closest('[data-document-previous]');
      const next=event.target.closest('[data-document-next]');
      if(page||close||previous||next)event.stopPropagation();
      if(page){this.trigger=page;this.showPage(Number(page.dataset.document));this.dialog.showModal();}
      if(close)this.dialog.close();
      if(previous)this.showPage((this.index+this.pages.length-1)%this.pages.length);
      if(next)this.showPage((this.index+1)%this.pages.length);
    },{signal:this.controller.signal});
    this.dialog.addEventListener('keydown',event=>{if(event.key==='Escape')event.stopPropagation();},{signal:this.controller.signal});
    this.dialog.addEventListener('close',()=>this.trigger?.focus({preventScroll:true}),{signal:this.controller.signal});
  }
  showPage(index){
    this.index=index;
    const page=this.pages[index],image=page.querySelector('img');
    this.image.src=image.currentSrc||image.src;
    this.image.alt=image.alt;
    this.documentTitle.textContent=page.querySelector('.bec-download-preview__caption').textContent;
    this.counter.textContent=(index+1)+' / '+this.pages.length;
  }
  disconnectedCallback(){this.controller?.abort();this.controller=null;}
}
if(!customElements.get('barbara-download-preview'))customElements.define('barbara-download-preview',BarbaraDownloadPreview);

class BarbaraStudioSquare extends HTMLElement {
  connectedCallback(){
    if(this.controller)return;
    this.controller=new AbortController();
    const video=this.querySelector('video');
    this.closest('slideshow-component')?.addEventListener('slideshow:select',()=>video?.pause(),{signal:this.controller.signal});
    this.addEventListener('click',event=>event.stopPropagation(),{signal:this.controller.signal});
  }
  disconnectedCallback(){this.controller?.abort();this.controller=null;}
}
if(!customElements.get('barbara-studio-square'))customElements.define('barbara-studio-square',BarbaraStudioSquare);
